/* eslint-disable import/no-extraneous-dependencies */
import { create } from 'zustand';
// create store
const useAudioStore = create((set) => ({
  audioPlay: false,
  changePlaying: () => set((state) => ({ audioPlay: !state.audioPlay })),
}));

export default useAudioStore;
